import clsx from 'clsx';

// Components
import {
    defaultTreeStructureAlbumCardStyle,
    defaultTreeStructureAlbumFeedGridStyle
} from '@/components/pages/albums/Albums/AlbumsFeed';

const AlbumsFeedPlaceholder = () => {
    return (
        <main
            className={clsx('animate-pulse', defaultTreeStructureAlbumFeedGridStyle)}
            data-testid="loading-data">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
                <span
                    key={item}
                    className={clsx(
                        'block h-96 w-full rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack',
                        defaultTreeStructureAlbumCardStyle
                    )}
                />
            ))}
        </main>
    );
};

export default AlbumsFeedPlaceholder;
